export default{
    pocket: '/pocket/:pocketCode/:access',
    home: '/ap',
    overview: 'overview',
    overviewIp: 'overviewIp',
    signIn: '/sign-in',
    signUp: '/sign-up',
    card: 'card',
    addAuthor: 'add-author-card',
    editAuthor: 'edit-author-card',
    addPublisher: 'add-publisher-card',
    editPublisher: 'edit-publisher-card',
    editPublication: 'edit-publication-card',
    addPublication: 'add-publication-card',
    communication: 'communication',
    subscription: 'subscription',
    security: 'security',
    account: 'account',
    payment: 'subscription/payment',
    verifyEmail: '/sign-in/:type/:verificationKey',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password/:verificationKey',
    resendVerificationEmail: '/resend-verification/',
    term: '/term-condition',
    privacy: '/privacy-policy',
    prohibitedBusiness: '/prohibited-business',
    ipHome: '/ip',
    authors: 'authors',
    publications: 'publications',
    publishers: 'publishers',
    details: 'details/:id',
    admin: '/aa',
    userOverview: 'user-overview',
    userSubscription: 'subscriptions',
    infoOverview: 'info-overview',
    infoAuthors: 'info-authors',
    infoArticles: 'info-articles',
    infoPublishers: 'info-publishers',
    infoPublications: 'info-publications',
    members: 'members',
    user: 'user',
    errorPage: 'error-page',

    // account confirmation
    organisationInvite: 'organisation-invite',
    billingManagerInvite: 'billing-manager-invite',
    collaboratorInvite: 'collaborator-invite',
    teamInvite: 'team-invite',
    claimRequestConfirmation: 'claim-request-confirmation',
    sourceConfirmation: 'source-confirmation',
    pocketConfirmation: 'pocket-confirmation',
    facebookConfirmation: 'facebook-confirmation',
    twitterConfirmation: 'twitter-confirmation',
    deleteUserAccount: 'delete-user-account',
    usersOverview: 'users-overview',

    // organisation
    organisationCard: 'organisation-card',
    organisations: 'organisations',
    organisationSettings: 'org-settings',
    organisationTeams: 'org-teams',
    orgAddTeams: 'add-team',
    editTeam: 'edit-team',
    organisationBilling: 'org-billing',
    organisationShortURL: 'org-short-url',
    organisationURLS: 'org-internal-urls',
    organisationActiveURLS: 'org-active-urls',
    organisationArchiveURLS: 'org-archive-urls',
    organisationURLDashboard: 'org-url-dashboard',
    organisationMemberPrevileges: 'org-member-previleges',
    organisationCollaborators: 'org-collaborators',
    organisationPublications: 'org-publications',
    orgAddPublication: 'org-add-publication',
    organisationArticles: 'org-articles',
    organisationAbout: 'org-about',
    organisationOverview: 'org-overview',
    organisationCollections: 'org-collections',
    organisationDossiers: 'org-dossiers',
    organisationCollectionPage: 'org-collection-page',
    organisationDossierPage: 'org-dossier-page',
    organisationPeople: 'org-people',
    addOrganisation: 'add-organisation',
    teamDossiers: 'teams-dossier',
    teamDossierPage: 'teams-dossier-page',
    teamOverview: 'teams-overview',
    teamCollections: 'teams-collection',
    teamCollectionPage: 'teams-collection-page',
    teamMembers: 'teams-members',
    teamSettings: 'teams-settings',

    // author page
    authorOverview: 'author-overview',
    authorArticles: 'author-articles',
    authorCollections: 'author-collections',
    authorCollectionPage: 'author-collections-page',
    authorDossiers: 'author-dossiers',
    authorDossierPage: 'author-dossiers-page',
    authorCollectionAboutPage: 'author-collection-about-page',
    authorDossierAboutPage:'author-dossier-about-page',
    authorAbout: 'author-about',
    authorSettings: 'author-settings',

    // publication page
    publicationOverview: 'publication-overview',
    publicationArticles: 'publication-articles',
    publicationCollections: 'publication-collections',
    publicationCollectionPage: 'publication-collections-page',
    publicationDossiers: 'publication-dossiers',
    publicationDossierPage: 'publication-dossiers-page',
    publicationCollectionAboutPage: 'publication-collection-about-page',
    publicationDossierAboutPage:'publication-dossier-about-page',
    publicationAbout: 'publication-about',
    publicationSettings: 'publication-settings',

    // publisher page
    publisherOverview: 'publisher-overview',
    publisherArticles: 'publisher-articles',
    publisherCollections: 'publisher-collections',
    publisherCollectionPage: 'publisher-collections-page',
    publisherDossiers: 'publisher-dossiers',
    publisherDossierPage: 'publisher-dossiers-page',
    publisherCollectionAboutPage: 'publisher-collection-about-page',
    publisherDossierAboutPage:'publisher-dossier-about-page',
    publisherAbout: 'publisher-about',
    publisherSettings: 'publisher-settings',

    // short url pages
    shortURLHome: 'short-url',
    shortURLSettings: 'short-url-settings',
    shortURLSettingsRegisteredURL: 'short-url-settings-registered-url',
    shortURLActiveURLS: 'short-url-active-urls',
    shortURLArchiveURLS: 'short-url-archive-urls',
    shortURLDashboard: 'short-url-url-dashboard',
    shortURLInternalSettings: 'short-url-url-settings',

    // location service pages
    locationHome: 'location-home',
    locationSettings: 'location-settings',
    locationservice: 'location-service',

    // IAM Dashboard
    IAMMainDashboard:'iam-dashboard',
    iamUser:'iam-user',
    iamUserGroup:'iamuser-group',
    iamCreateGroup:'iam-create-group',
    iamEditGroup:'iam-create-group/edit/:id',
    iamRoles: 'iam-roles',
    iamCreateRole: 'iam-create-role',

    // Publisher API
    publisherAPI: 'publisherAPI'
}